import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function ConfirmEmailPage() {
  const [status, setStatus] = useState("Confirming your account...");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (!token) {
      setStatus("Invalid confirmation link.");
      setLoading(false);
      return;
    }

    const confirm = async () => {
      try {
        const res = await fetch(`/auth/confirm-email?token=${encodeURIComponent(token)}`, {
          method: "GET",
          credentials: "include",
        });

        const data = await res.json();
        if (!res.ok) {
          setStatus(data.error || "Confirmation failed.");
          setLoading(false);
          return;
        }

        setStatus("✅ Account confirmed! Redirecting...");
        setLoading(false);

        // ✅ After successful confirmation, immediately redirect to complete profile
        setTimeout(() => {
          navigate("/complete-profile");
        }, 1000);

      } catch (err) {
        console.error("❌ Confirm email error:", err);
        setStatus("Something went wrong. Please try again.");
        setLoading(false);
      }
    };

    confirm();
  }, [location, navigate]);

  return (
    <div
      style={{
        padding: "40px",
        textAlign: "center",
        backgroundColor: "#2c7373",
        minHeight: "100vh",
        color: "white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <img
        src="/campwithfriends-logo.png"
        alt="Camp With Friends Logo"
        style={{
          width: "200px",
          marginBottom: "30px",
        }}
      />
      {loading && (
        <div style={{ marginBottom: "20px" }}>
          <div
            className="spinner"
            style={{
              margin: "20px auto",
              border: "4px solid #f3f3f3",
              borderTop: "4px solid #ffffff",
              borderRadius: "50%",
              width: "40px",
              height: "40px",
              animation: "spin 1s linear infinite"
            }}
          ></div>
        </div>
      )}
      <h2 style={{ fontSize: "1.5rem" }}>{status}</h2>

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}

export default ConfirmEmailPage;
